import { update_billing_state, } from 'console/billing/redux/actions';
import { openErrorDialog, } from 'console/dialogs/error/redux/actions';
export const loadTariffs = () => async (dispatch, getState, { api }) => {
    dispatch({ type: 'LOAD_TARIFFS__REQUEST' });
    try {
        const response = await api.get_tariffs();
        dispatch({ type: 'LOAD_TARIFFS__OK', tariffs: response.tariffs });
    }
    catch (error) {
        console.error(error);
        dispatch({ type: 'LOAD_TARIFFS__FAIL' });
    }
};
export const downgradeTariff = (targetTariff) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'CHANGE_TARIFF__REQUEST' });
    try {
        const response = await api.downgrade_tariff(targetTariff);
        dispatch({ type: 'CHANGE_TARIFF__OK' });
        dispatch(update_billing_state(response.billing_state));
    }
    catch (error) {
        dispatch({ type: 'CHANGE_TARIFF__FAIL' });
        dispatch(openErrorDialog(error?.json));
    }
};
export const cancelTariffDowngrade = () => {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: 'CHANGE_TARIFF__REQUEST' });
        try {
            const response = await api.cancel_tariff_downgrade();
            dispatch({ type: 'CHANGE_TARIFF__OK' });
            dispatch(update_billing_state(response.billing_state));
        }
        catch (error) {
            dispatch({ type: 'CHANGE_TARIFF__FAIL' });
            dispatch(openErrorDialog(error?.json));
        }
    };
};
